"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _KnockItemHeader = require("./KnockItemHeader");
Object.keys(_KnockItemHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _KnockItemHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _KnockItemHeader[key];
    }
  });
});